export default __webpack_public_path__ + "static/media/stroke.e641de0f.png";